import React from 'react';
import styled from 'styled-components';
import { Block } from '../design-system';
import { FaExclamationTriangle } from 'react-icons/fa';

const fontSize = 1.8;

const Container = styled.div`
  max-width: 600px;
  text-align: center;
  padding: 0 20px;
`;

const Header = styled(Block)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledFaExclamationTriangle = styled(FaExclamationTriangle)`
  font-size: ${fontSize}rem;
  margin-right: 10px;
`;

const Title = styled.h1``;

const Paragraph = styled.p`
  margin-bottom: 5px;
`;

export default () => (
  <Block
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    height="100%"
  >
    <Container>
      <Header>
        <StyledFaExclamationTriangle />
        <Title>Error</Title>
      </Header>
      <Paragraph>
        An error has occurred. Our team has been notified and is working on it.
      </Paragraph>
      <Paragraph>Please refresh and try again</Paragraph>
    </Container>
  </Block>
);
